import classNames from 'classnames';
import './ContentHighlightWrapper.scss';

export interface ContentHighlightWrapperProps {
  /** The tile element at top of the content highlight */
  mediaManager?: React.ReactNode;
  /** Controls the padding of the content */
  size?: 'small' | 'large';
  /** Optional class */
  className?: string;
  /** Content details section */
  children: React.ReactNode;
}

/**
 * ContentHighlightWrapper - a wrapper for a top tile element and content details section.
 * @param mediaManager - the tile element at top of the content highlight
 * @param size - controls the padding of the content. default large
 * @param className - optional class
 * @param children - content details section
 */
export const ContentHighlightWrapper: React.FC<ContentHighlightWrapperProps> = ({
  mediaManager,
  size = 'large',
  className,
  children,
  ...rest
}) => (
  <div className={classNames('vds-content-highlight-wrapper', className)} {...rest}>
    {mediaManager}
    <div
      className={classNames(
        'vds-content-highlight-wrapper__content',
        `vds-content-highlight-wrapper__content--${size}`,
      )}>
      {children}
    </div>
  </div>
);
